import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { navigate } from 'gatsby'
import { Helmet } from 'react-helmet'

import Button from '../../components/Button'
import Heading from '../../components/Heading'
import Layout from '../../components/Layout'
import Table from '../../components/Table'
import Search from '../Search'
import { useWithAuth } from '../../containers/App'
import { useNotifications } from '../../containers/Notifications'
import { normalizeSortState } from '../../components/Table/convertSortState'
import withLoading from '../../utils/withLoading'
import { voivodeships, UnitsListProps, unitTypes } from './utils'
import colors from '../../styles/colors'
// @ts-ignore @todo add apprioprate declaration file
import addIcon from '../../images/addIcon.svg'
// @ts-ignore @todo add apprioprate declaration file
import rightIcon from '../../images/rightIcon.svg'
// @ts-ignore @todo add apprioprate declaration file
import closeIconRed from '../../images/closeIcon-red.svg'
import { Hidden } from '../../styles/Shared'

//const endpoint = '/report/rest/examination'

function UnitsList() {
  const LoadingTable = withLoading(Table)
  const [units, setUnits] = useState<UnitsListProps[]>()
  const [ready, setReady] = useState<boolean>(false)
  const [state, setState] = useState({
    sorts: {},
    meta: {
      limit: 10,
      page: 0,
      total: 0,
    },
    filters: { search: '' },
  })
  const withAuth = useWithAuth()
  const { notify } = useNotifications()
  const endpoint = '/diagnostic/rest/unit/search'
  const onSortedChange = (sort) => {
    setState({ ...state, sorts: sort })
  }
  const onPageChange = (index) => {
    setState({ ...state, meta: { ...state.meta, page: index } })
  }

  const fetchUnits = async () => {
    setReady(false)
    const result = await withAuth(`${endpoint}`, {
      method: 'POST',
      payload: {
        filters: { ...state.filters },
        meta: { ...state.meta, sorts: normalizeSortState(state.sorts) },
      },
    })
    setReady(true)
    return result
  }

  const fetchData = async () => {
    try {
      const result = await fetchUnits()
      setUnits(result.models)
      setState({ ...state, meta: { ...state.meta, total: result.meta.total } })
    } catch {
      notify('Nie udało się pobrać listy jednostek', 'error')
    }
  }
  useEffect(() => {
    fetchData()
  }, [state.sorts, state.filters.search, state.meta.page])

  useEffect(() => {
    if (!units?.length) {
      const elements = document.getElementsByClassName('rt-noData')
      if (elements) {
        for (const element of elements) {
          element.setAttribute('tabindex', '0')
          element.setAttribute('role', 'alert')
        }
      }
    }
  })

  const onSearchChange = (search) => {
    setState((prevState) => ({
      ...prevState,
      filters: { ...prevState.filters, search },
      meta: { ...prevState.meta, page: 0 },
    }))
  }

  return (
    <Layout>
      <Heading title="Lista Jednostek">
        <div style={{ width: '100%' }}>
          <label>
            <Search
              width={450}
              ariaLabel={
                state.filters.search
                  ? `Szukaj liczba znalezionych wyników: ${
                      units != null ? units.length : 0
                    }`
                  : 'Szukaj'
              }
              placeholder="Szukaj"
              input={{
                onChange: onSearchChange,
                value: '',
              }}
            />
          </label>
        </div>

        <Button
          link="/app"
          label="Powrót"
          icon={closeIconRed}
          width="auto"
          color="white"
          altTag=""
          imgAriaHidden={true}
          srText=""
        />
        <Button
          link="/app/units/add"
          label="Dodaj Jednostkę"
          icon={addIcon}
          width="auto"
          marginLeft
          altTag=""
          imgAriaHidden={true}
          srText=""
        />
      </Heading>
      <PanelWrapper>
        <LoadingTable
          page={state.meta.page}
          total={state.meta?.total}
          defaultPageSize={state.meta.limit}
          onSortedChange={(s) => onSortedChange(s)}
          onPageChange={(index) => onPageChange(index)}
          order={state.sorts}
          ready={ready}
          data={units}
          getTheadTrProps={() => ({
            style: { display: 'flex', alignItems: 'center' },
          })}
          columns={[
            {
              Header: 'Identifikator RSPO',
              id: 'rspo',
              sortable: true,
              accessor: ({ rspo }) => rspo,
              getProps: () => ({
                role: undefined,
              }),
            },
            {
              Header: 'Typ',
              sortable: true,
              id: 'publicUnit',
              accessor: ({ publicUnit }) =>
                unitTypes.find((value) => value.value === publicUnit)?.label,
              getProps: () => ({
                role: undefined,
              }),
            },

            {
              Header: 'Nazwa',
              sortable: true,
              id: 'name',
              accessor: ({ name }) => name,
              getProps: () => ({
                role: undefined,
              }),
            },

            {
              Header: 'Województwo',
              id: 'voivodeship',
              sortable: true,

              accessor: ({ voivodeship }) =>
                voivodeships.find((value) => value.value === voivodeship)
                  ?.label,
              getProps: () => ({
                role: undefined,
              }),
            },
            {
              Header: 'Kod pocztowy',
              id: 'postcode',
              sortable: true,
              accessor: ({ postcode }) => postcode,
              getProps: () => ({
                role: undefined,
              }),
            },

            {
              Header: 'Miejscowość',
              id: 'city',
              sortable: true,
              accessor: ({ city }) => city,
              getProps: () => ({
                role: undefined,
              }),
            },
            {
              Header: 'Ulica i numer domu',
              id: 'address',
              sortable: true,
              accessor: ({ address }) => address,
              getProps: () => ({
                role: undefined,
              }),
            },
            {
              Header: <Hidden>Szczegóły jednostki</Hidden>,
              sortable: false,
              Cell: ({ original }) => (
                <IconButton
                  type="button"
                  onClick={() =>
                    navigate(`${original.id}`, {
                      state: {
                        unit: original,
                      },
                    })
                  }
                >
                  Zobacz szczegóły
                  <Img alt="" src={rightIcon} aria-hidden="true" />
                </IconButton>
              ),
            },
          ]}
        />
      </PanelWrapper>
    </Layout>
  )
}

export default UnitsList

const PanelWrapper = styled.div`
  padding: 2em;
`
const Img = styled.img`
  margin-bottom: 0;
`

const IconButton = styled.button`
  display: flex;
  position: absolute;
  min-width: 150px;
  margin: 0;
  background: white;
  border: 1px solid ${colors.light_black};
  &:hover {
    ${(props) => !props.disabled && `border: 1px solid ${colors.mantis_green};`}
  }
  &.danger {
    &:hover {
      border: 1px solid ${colors.red};
    }
  }
  align-items: center;
  cursor: ${(props) => !props.disabled && `pointer;`};
  height: auto;
  border-radius: 5px;
  > * {
    padding: 0 0 0 3px;
  }
  ${Img} {
    opacity: ${(props) => props.disabled && `50%`};
  }
`
